(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/inline-message/assets/inline-message.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/inline-message/assets/inline-message.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const Button = svs.ui.ReactButton;

const InlineMessage = _ref => {
  let actions = _ref.actions,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    header = _ref.header,
    icon = _ref.icon,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '900' : _ref$size,
    isError = _ref.isError,
    _ref$buttonOptions = _ref.buttonOptions,
    buttonOptions = _ref$buttonOptions === void 0 ? {
      inverted: true
    } : _ref$buttonOptions;
  return React.createElement("div", {
    className: "margin-top-1 ".concat(className)
  }, React.createElement("div", {
    className: "u-text-center"
  }, icon && React.createElement(Icon, {
    className: "margin-bottom-1",
    color: "".concat(isError && 'fc-red'),
    icon: icon,
    size: size
  }), header && React.createElement("h2", {
    className: "h2"
  }, React.createElement("span", {
    className: "f-medium"
  }, header))), typeof children === 'string' && React.createElement("p", {
    className: "u-text-center"
  }, children), typeof children !== 'string' && React.createElement("div", {
    className: "u-text-center"
  }, children), actions && (actions === null || actions === void 0 ? void 0 : actions.length) >= 1 && actions.map(action => React.createElement("div", {
    className: "margin-v-1 margin-top-2 align-center",
    key: action.text
  }, React.createElement(Button, {
    block: buttonOptions.block,
    href: action.href,
    inverted: buttonOptions.inverted,
    onClick: action.handleClick,
    size: 300,
    transparent: buttonOptions.transparent
  }, action.text))));
};
svs.components.tb_ui_react.inlineMessage.InlineMessage = InlineMessage;

 })(window);